import React from 'react';
import styles from './TransitionedOverlay.module.scss';

type TransitionedOverlayProps = {
  isTransitioned: boolean;
  children: React.ReactNode;
};

function TransitionedOverlay({
  isTransitioned,
  children,
}: TransitionedOverlayProps) {
  if (!isTransitioned) {
    return children;
  }

  return (
    <div className={styles.container}>
      {children}
      <div className={styles.overlay} />
    </div>
  );
}

export default TransitionedOverlay;
